import React, { type SyntheticEvent } from 'react';
import type { TagColor } from '@atlaskit/tag';
import Tooltip from '@atlaskit/tooltip';
import checkForHref from '@atlassian/jira-common-components-html-view/src/check-for-href';
import { AsyncEpicCard } from '@atlassian/jira-epic-card';
import { useIntl } from '@atlassian/jira-intl';
import {
	type Color,
	MAP_COLOR_TO_AK_COLOR,
	getLozengeThemeByColor,
} from '@atlassian/jira-issue-epic-color';
import type { SelectValueShape } from '@atlassian/jira-issue-internal-field-select';
import { EmptyValue } from '@atlassian/jira-issue-view-common-styles';
import { toIssueKey } from '@atlassian/jira-shared-types';
import messages from '../messages';
import { TagWrapper, TagWrapperNoClick } from './styled';

export type Props = {
	value: SelectValueShape | null | undefined;
	noValueText: string | null | undefined;
	isMobile: boolean;
};

// type assertion is fine as the record key is of type Color
const findColor = (color: TagColor) =>
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	(Object.keys(MAP_COLOR_TO_AK_COLOR) as Array<Color>).find(
		(key) => MAP_COLOR_TO_AK_COLOR[key] === color,
	);

const handleMouseDown = (e: SyntheticEvent<HTMLElement>) => {
	// @ts-expect-error - TS2559 - Type 'EventTarget' has no properties in common with type 'ElementToCheck'.
	if (checkForHref(e.target, e.currentTarget)) {
		e.stopPropagation();
	}
};

export const InlineReadView = ({ value, noValueText, isMobile }: Props) => {
	const { formatMessage } = useIntl();

	return (
		<>
			{value?.content ? (
				<AsyncEpicCard issueKey={toIssueKey(value.value.toString())} epicName={value.content}>
					<Tooltip content={value?.content.length > 20 ? value?.content : ''}>
						<div
							onClick={handleMouseDown}
							onMouseDown={handleMouseDown}
							onKeyPress={handleMouseDown}
							role="presentation"
						>
							{isMobile ? (
								<TagWrapperNoClick
									/* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */
									style={getLozengeThemeByColor(findColor(value.color))}
								>
									{value.content}
								</TagWrapperNoClick>
							) : (
								<TagWrapper
									href={value.href}
									aria-label={`${formatMessage(messages.epicTitle)} ${value.content}`}
									/* eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */
									style={getLozengeThemeByColor(findColor(value.color))}
								>
									{value.content}
								</TagWrapper>
							)}
						</div>
					</Tooltip>
				</AsyncEpicCard>
			) : (
				<EmptyValue>{noValueText}</EmptyValue>
			)}
		</>
	);
};
